import furnitureImage from "../../assets/categories/furniture.png";
import kitchenImage from "../../assets/categories/kitchen.png";
import homeDecorImage from "../../assets/categories/home-decor.png";
import newArrivalsImage from "../../assets/categories/new-arrivals.png";
import collectionsImage from "../../assets/categories/collections.png";
import servewareImage from "../../assets/categories/kitchen-collections.png";
import dinnerwareImage from "../../assets/categories/dinnerware.png";
import beddingImage from "../../assets/categories/bedding.png";
import livingRoomFurnitureImage from "../../assets/categories/living-room.png";
import roomDecorImage from "../../assets/categories/room-decor.png";
import bedroomFurnitureImage from "../../assets/categories/bedroom-furniture.png";
import barGlasswareImage from "../../assets/categories/bar-and-glass.png";
import cheeseTrayImage from "../../assets/categories/menu.png";
import dressersImage from "../../assets/categories/dressers.png";
import tablesImage from "../../assets/categories/table.png";
import bowlsImage from "../../assets/categories/bowls.png";
import barImage from "../../assets/categories/bar.png";
import sofaImage from "../../assets/categories/sofa.png";
import minimalistImage from "../../assets/categories/minimalist.png";
import bakewareImage from "../../assets/categories/bakeware.png";
export const categoryImagesMap = {
    furniture: furnitureImage,
    kitchen: kitchenImage,
    "home-decor": homeDecorImage,
    "new-arrivals": newArrivalsImage,
    collections: collectionsImage,
    serveware: servewareImage,
    dinnerware: dinnerwareImage,
    "living-room-furniture": livingRoomFurnitureImage,
    bedding: beddingImage,
    "room-decor": roomDecorImage,
    "bedroom-furniture": bedroomFurnitureImage,
    "bar-and-glassware": barGlasswareImage,
    "cheese-trays": cheeseTrayImage,
    "storage--tables": dressersImage,
    tables: tablesImage,
    bowls: bowlsImage,
    "bar-accessories": barImage,
    sofas: sofaImage,
    "the-minimalist": minimalistImage,
    bakeware: bakewareImage,
};
